import _asyncToGenerator from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import { RequestNetworkError } from '../core/RequestError';
import { checkMock } from '../middlewares/mock';
var IS_STD_PROTOCOL = typeof window !== 'undefined' ? /^(https:|http:)/.test(location.protocol) : false;

function jsonp(url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!IS_STD_PROTOCOL) {
    url = url.replace(/^(\w+:)?/, 'https:');
  }

  data = Object.assign({
    otype: 'json'
  }, data);
  return new Promise(function (resolve, reject) {
    $.ajax($.extend({
      url: url,
      dataType: 'jsonp',
      data: data,
      success: function success(json) {
        if (json) {
          resolve(json);
        } else {
          reject(new RequestNetworkError());
        }
      },
      error: function error(xhr, errType) {
        if (errType === 'timeout') {
          reject(new RequestNetworkError('网络返回超时！请重试'));
        } else {
          reject(new RequestNetworkError());
        }
      }
    }, options));
  });
}

export default function () {
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!checkMock(this)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            if (!(typeof $ === 'undefined')) {
              _context.next = 4;
              break;
            }

            throw new Error('需要在页面中引入zepto来发送jsonp请求');

          case 4:
            _context.next = 6;
            return jsonp(this.request.url, this.request.data, this.request.options);

          case 6:
            this.response = _context.sent;

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
}